import attachmentServices from '../../services/attachment';
import Attachment from '../../model/attachment';

export const state = {
    attachments: [],
    attachment: {},
}

export const mutations = {
    setAttachment(state, attachment) {
        state.attachment = attachment
    },
    setAttachments(state, attachments) {
        state.attachments = attachments
    },
    addAttachment(state, attachment) {
        state.attachments = [attachment, ...state.attachments]
    },
}

export const getters = {
    getAttachment(state) {
        return new Attachment(state.attachment);
    },
    getAttachments(state) {
        return state.attachments.map((x)=>new Attachment(x))
    },
}

export const actions = {
    get({commit}, id){
        return attachmentServices.get(id)
        .then((response)=>{
            commit('setAttachment', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return attachmentServices.getAll(data)
        .then((response)=>{
            commit('setAttachments', response.data.data)
            return response
        })
    },
    add({commit}, attachment){
        return attachmentServices.add(attachment)
        .then((response)=>{
            commit('addAttachment', response.data.data)
            return response
        })
    },
    edit({commit, state}, {id, attachment}){
        return attachmentServices.edit(id, attachment)
        .then((response)=>{
            let attachments = state.attachments
            attachments[attachments.findIndex((x)=>x.id == id)] = response.data.data
            commit('setAttachments', attachments)
            return response
        })
    },
    delete({commit}, id){
        return attachmentServices.delete(id)
        .then((response)=>{
            commit('setAttachments', (state.attachments.filter((x)=>x.id != id)))
            return response
        })
    },
}